// rootReducer.js

import { combineReducers } from 'redux';
import loginreducer from './Login/LoginReducer.js';
import Ibleaddetailsreducer from './Ibleaddetails/leadreducer.js';
import sessionReducer from './RTCSession/sessionReducer.js';
import callinfoReducer from './CallInfo/callinforReducer.js';
const rootReducer = combineReducers({
  auth: loginreducer,
  ibleaddetails : Ibleaddetailsreducer,
  session: sessionReducer,
  callinfo: callinfoReducer
  // Add other reducers here if needed
});

export default rootReducer;
